import React from 'react';

import { bibShape } from '@bibliocommons/bc-prop-types';
import FormatIcon from '@bibliocommons/format-icon';

import FormatInfoContainer from 'app/components/shared/FormatInfo/FormatInfoContainer';

import './ItemFormat.scss';

export default function ItemFormat({ bib }) {
  const format = bib.getIn(['briefInfo', 'format']);

  if (!bib) {
    return null;
  }

  return (
    <div className="cp-item-format">
      <FormatIcon aria-hidden className="icon-format" format={format} />
      <FormatInfoContainer item={bib} showCallNumber={false} />
    </div>
  );
}

ItemFormat.propTypes = {
  bib: bibShape
};
